import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl } from 'react-intl'
import { LAYOUT_NAME_MAX_LENGTH } from 'const/limits'
import AddNewLayoutForm from './AddNewLayoutForm'

export class AddNewLayout extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,

    isTemplate: PropTypes.bool.isRequired,
    addToMyHomeLayout: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,

    requestAddLayout: PropTypes.func.isRequired
  }

  static defaultProps = {
    isTemplate: false,
    addToMyHomeLayout: false
  }

  handleFormValidate = ({ name }) => {
    const errors = {}
    if (name && name.length > LAYOUT_NAME_MAX_LENGTH) {
      errors.name = this.props.intl.formatMessage({ id: 'DESK_NAME_TOO_LONG' }, { limit: LAYOUT_NAME_MAX_LENGTH })
    }
    return errors
  }

  handleFormSubmit = ({ template, name }) => {
    const { isTemplate, addToMyHomeLayout, close, requestAddLayout } = this.props

    if (name) {
      requestAddLayout({
        template: template !== 'empty' ? { type: 'board-collection', id: +template } : 'empty',
        isTemplate,
        name,
        position: 0,
        addToMyHomeLayout
      })
    }

    close()
  }

  render () {
    const {
      isTemplate
    } = this.props

    return (
      <AddNewLayoutForm
        isTemplate={isTemplate}
        validate={this.handleFormValidate}
        onSubmit={this.handleFormSubmit}
      />
    )
  }
}

export default injectIntl(AddNewLayout)
